module.exports = __webpack_public_path__ + "img/scope_arb_2.42e1a970.svg";